import vm from '@/business/main'
import Bussiness from 'Utils/business'

/**
 * 火车票退单类
 * @param {Object} detail 火车票退单详
 */

export default {
  /**
   * 取消改签
   */
  async cancel (detail) {
    await vm.$dialog.confirm({
      message: '您确定要取消退票吗？',
    }).then(async () => {
      try {
        await vm.$api['trOrder/cancelTrRefund']({ id: detail.id })
        return true
      } catch (res) {
        return res
      }
    })
  },
  /**
   * 送审
   */
  approval (detail) {
    detail.orderType = $dict.ORDER_TYPE.tr.change
    Bussiness.ApprovalSend(detail, () => {
      // vm.init()
    })
  }
}